/**
 * Client-side password policy. Mirrors the server-side rules in
 * apps/api/Auth/PasswordPolicy.cs; the API is the source of truth and re-checks.
 */

import { messagesFor } from '../i18n/messages'
import { passwordMessages } from '../i18n/text/password'

export const PASSWORD_MIN_LENGTH = 10

/** Short helper text shown under password fields. */
export const PASSWORD_RULE_TEXT = messagesFor(passwordMessages, 'is').ruleText

/** Full validation message returned when a password is too weak. */
export const PASSWORD_ERROR = messagesFor(passwordMessages, 'is').error

export const PASSWORD_MISMATCH = messagesFor(passwordMessages, 'is').mismatch

/** Returns an error message if the password is too weak, or null if it passes. */
export function validatePassword(password: string): string | null {
  const strong =
    password.length >= PASSWORD_MIN_LENGTH &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password)
  return strong ? null : messagesFor(passwordMessages).error
}

export interface PasswordCheck {
  label: string
  met: boolean
}

/** Per-requirement pass/fail, for a live checklist under a password field. */
export function passwordChecks(password: string): PasswordCheck[] {
  const m = messagesFor(passwordMessages)
  return [
    { label: m.checkLength(PASSWORD_MIN_LENGTH), met: password.length >= PASSWORD_MIN_LENGTH },
    { label: m.checkUpper, met: /[A-Z]/.test(password) },
    { label: m.checkLower, met: /[a-z]/.test(password) },
    { label: m.checkDigit, met: /[0-9]/.test(password) },
  ]
}
